export const templatesIndex = {
  header: {
    title: "WhatsApp Templates",
    description:
      "Create and edit templates just like in Meta (header/body/footer/buttons + preview).",
    create: "Create template",
  },
  notConnected:
    'Your account has no WhatsApp Business connected (WABA). Connect it first under "WhatsApp Business".',
  filters: {
    search: "Search",
    searchPlaceholder: "Search by name...",
    status: "Status",
    all: "All",
    category: "Category",
    allFem: "All",
    language: "Language",
    refresh: "Refresh",
  },
  list: {
    loading: "Loading templates...",
    emptyTitle: "No templates",
    emptyText: "Try changing the filters or create your first template.",
    baseBadge: "Base",
    edit: "Edit",
    duplicate: "Duplicate",
    deleteProtected: "Base template: cannot be deleted",
    delete: "Delete",
    prev: "← Previous",
    next: "Next →",
  },
  preview: {
    noText: "(no text)",
    noContent: "No content",
  },
  time: {
    now: "Now",
    minutesAbbr: "{n} min",
    hoursAbbr: "{n}h",
  },
  common: {
    close: "Close",
    cancel: "Cancel",
  },
  editor: {
    createTitle: "Create template",
    editTitle: "Edit template",
    sectionBasic: "Basic",
    name: "Name (snake_case)",
    nameHintHtml:
      "Spaces become <code>_</code>. Only <code>a-z</code>, <code>0-9</code> and <code>_</code>.",
    language: "Language",
    category: "Category",
    sectionHeader: "Header",
    enable: "Enable",
    type: "Type",
    headerLocationHintHtml:
      "LOCATION header carries no text or examples in the template. The location (lat/lng + name/address) is sent when the message is delivered via <code>/messages</code>.",
    headerMediaHint:
      "If you use MEDIA, your account may require examples/handles during review.",
    headerTextLabel: "Text (max 60)",
    headerTextPlaceholder: "E.g. Hi {{1}}, your booking is ready.",
    insert: "Insert",
    autoExample: "Auto example",
    examplesHeader: "Examples (header)",
    remove: "Remove",
    headerLocationNote: "A map card will be sent at the start of the message.",
    headerMediaNote: "This header will be shown as an attachment (media).",
    sectionBody: "Body",
    bodyPlaceholder: "Write the content. Use {{1}}, {{2}}...",
    examplesBody: "Examples (body)",
    sectionFooter: "Footer",
    footerPlaceholder: "Short text (optional, max 60)",
    sectionButtons: "Buttons",
    addButton: "+ Add",
    noButtons: "No buttons (optional).",
    buttonTextPlaceholder: "Button text (max 25)",
    removeButton: "Delete",
    previewTitle: "Preview",
    viewPayload: "View the payload sent to Meta",
    metaDebug: "Meta response / error (debug)",
    validReady: "Ready to save.",
    validIncomplete: "Complete the required fields before saving.",
    saving: "Saving...",
    save: "Save",
  },
  delete: {
    title: "Delete template",
    irreversible: "This action cannot be undone.",
    willDeletePre: "The template ",
    willDeletePost: " will be deleted.",
    confirmLabel: "Type the exact name to confirm:",
    confirmPlaceholder: "Type the name exactly",
    confirmHint: "The button is enabled when the text matches exactly.",
    deleting: "Deleting...",
    confirmDelete: "Delete permanently",
  },
  errors: {
    nameRequired: "The name is required.",
    nameInvalid: "Invalid format. Use only a-z, 0-9 and _.",
    headerRequired: "Header text is required if the header is enabled.",
    headerMax: "Header text is 60 characters max.",
    bodyRequired: "The body is required.",
    bodyMax: "Body is 1024 characters max.",
    footerMax: "Footer is 60 characters max.",
    buttonTextRequired: "Button text is required.",
    buttonTextMax: "25 characters max.",
    phoneInvalid: "PHONE_NUMBER must be E.164 (e.g. +34123456789).",
    urlInvalid: "URL must start with http:// or https://",
    loadDetail: "The template details could not be loaded.",
    save: "Error saving the template.",
    deleteFailed: "The template could not be deleted.",
  },
  duplicate: {
    defaultBody: "Template copy. Edit the content. Thank you {{1}}.",
  },
};
